import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SaveDialogComponent } from './save-dialog.component';
import { VerifyEmailFormModule } from '../verify-email-form/verify-email-form.module';
import { DialogCloseModule } from '../dialog-close/dialog-close.module';
import { TranslateModule } from '@xref/ngx';
import { VerifyCodeFormModule } from '../verify-code-form/verify-code-form.module';

@NgModule({
  declarations: [SaveDialogComponent],
  imports: [
    CommonModule,
    VerifyEmailFormModule,
    VerifyCodeFormModule,
    DialogCloseModule,
    TranslateModule
  ],
  exports: [SaveDialogComponent]
})
export class SaveDialogModule { }
